<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-21 10:58:29
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-06-24 16:56:58
 * @FilePath: \sns-user-frontend\src\components\web\footer.vue
 * @Description: pc端页脚
-->
<template>
  <footer v-if="!hideNavigation" class="footer"
    :style="{
      position: isFixed ? 'fixed' : 'relative',
      opacity: footerOpacity
    }"
  >
    <div class="footer-main">
      <!-- 协议 -->
      <div class="footer-l">
        <dl>
          <template v-for="(contract, index) in contractList">
            <dt v-if="contract.show">
              <router-link 
                @click="clickLink(contract)"
                v-if="!contract.thirdPartLink"
                :to="{
                  name: contract.path
                }"
              >
                {{$t(contract.label)}}
              </router-link>
              <!-- 外部协议链接 -->
              <a @click="clickLink(contract)" v-if="contract.thirdPartLink" :href="contract.thirdPartLink" target="_blank">{{$t(contract.label)}}</a>
            </dt>
          </template>
        </dl>
        <!-- 版权所属 -->
        <a 
          @click="toSearchCopyRight('copyRight')"
          :class="`${isChina ? 'zh-' : ''}copy-right`"
          target="_blank"
        >
          {{$t(`${brandName}CopyRight`)}}
        </a>
        <!-- 国内备案 -->
        <a
          class="china-ip-records"
          v-if="isChina"
          @click="toSearchCopyRight('record')"
          target="_blank"
        >
          <img lazy src="../../assets/photo/badge.webp" alt="粤公网安备 44030402001407号" />
          <span>粤公网安备 44030402001407号</span>
        </a>
      </div>
      <!-- 海外社交媒体 -->
      <dl class="footer-r" v-if="!isChina">
        <dt
          v-for="(icon, index) in socicalIconList"
          :key="index"
        >
          <a @click="clickMedia(icon)" :href="icon.link" target="_blank">
            <svg-icon v-if="!icon.hide" :name="`icon-foot-${icon.name}`"/>
          </a>
        </dt>
      </dl>
    </div>
  </footer>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, nextTick } from 'vue';
import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

const systemStore = useSystemStore()
const { brandName, hideNavigation } = storeToRefs(systemStore)
const isChina = import.meta.env.VITE_COUNTRY === 'CHINA'
const isOneplusOversea = import.meta.env.VITE_COUNTRY === 'PARIS'
const isOppoGlobal = import.meta.env.VITE_COUNTRY === 'GLOBAL'
const isOneplus = import.meta.env.VITE_COUNTRY === 'CHINA' || import.meta.env.VITE_COUNTRY === 'PARIS'

const { proxy } = getCurrentInstance()
const route = useRoute()

const isFixed = ref(false)
const footerOpacity = ref(0)

// 协议列表
const contractList = reactive([
  {
    label: 'feedBack',
    thirdPartLink: `${location.origin}/feedback`,
    show: isOneplusOversea,
  },
  {
    label: 'support',
    thirdPartLink: `${location.origin}/support`,
    show: isOneplus,
  },
  {
    label: 'privacyNotice',
    path: "privacyNotice",
    show: true,
  },
  {
    label: 'termsOfUse',
    path: "termsOfUse",
    show: import.meta.env.VITE_COUNTRY !== 'CHINA',
  },
  {
    label: 'userAgreement',
    path: "userAgreement",
    show: import.meta.env.VITE_COUNTRY !=='IN',
  },
  {
    label: 'useOfCookies',
    show: isOneplusOversea,
    path: 'useOfCookies',
  },
  {
    label: 'cookiesStatement',
    path: 'useOfCookies',
    show: isOppoGlobal,
  },
  {
    label: 'webRate',
    thirdPartLink: 'https://community.oppo.com/form/1661435368345436167',
    show: isOppoGlobal,
  }
])

// 官方社交媒体渠道
const socicalIconList = reactive([
  {
    name: "facebook",
    link: import.meta.env.VITE_FACEBOOK,
  },
  {
    name: "ins",
    link: import.meta.env.VITE_INS,
  },
  {
    name: "twitter",
    link: import.meta.env.VITE_TWITTER,
  },
  {
    name: "youtube",
    link: import.meta.env.VITE_YOUTUBE,
  },
  {
    name: "whatsapp",
    link: import.meta.env.VITE_WHATSAPP,
    hide: import.meta.env.VITE_COUNTRY !== 'IN'
  },
])

// 监听容器窗口高度，页脚固定底部
const resizeObserver = new ResizeObserver(entries => {
  const appContainer = entries[0]
  if (appContainer) {
    const { height } = appContainer.contentRect
    isFixed.value = height <= document.documentElement.clientHeight
    footerOpacity.value = 1
  }
});

// 国内前往备案查询网站
const toSearchCopyRight = (type) => {
  if (import.meta.env.VITE_COUNTRY === 'CHINA') {
    const link = type === 'copyRight' ? 'https://beian.miit.gov.cn/#/Integrated/index' : 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402001407'
    window.open(link)
  }
}

const clickLink = (item) => {
  proxy.$ga('click_bottom_nav', {
    "screen_name": route.name,
    "nav_name": item.label
  })
}

const clickMedia = (item) => {
  proxy.$ga('click_bottom_media', {
    "screen_name": route.name,
    "method": item.name
  })
}

onMounted(() => {
  setTimeout(() => {
    resizeObserver.observe(document.querySelector('#app'))
  }, 1000);
  nextTick(() => {
    const existDom = Array.from(document.querySelector('.footer-l').querySelectorAll('dt')).filter(i => i.children?.length)
    console.log(existDom)
    existDom[0].style.paddingLeft = 0
    existDom[existDom.length - 1].style.border = 'none'
  })
})
</script>

<style lang="postcss" scoped>
.footer {
  bottom: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 1200px;
  height: 144px;
  background-color: var(--color-background-secondary);
  z-index: 10;
  &-main {
    width: 1200px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }
  dl {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
  }
  dt {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 120%;
  }
  &-l {
    dl {
      margin-bottom: 8px;
    }
    dt {
      position: relative;
      padding: 0 12px;
      border-right: 1px solid var(--line);
      a {
        font-size: 16px;
        color: var(--color-text-disabled);
        line-height: 19.2px !important;
        &:hover {
          color: rgba(0, 0, 0, .55);
        }
      }
      &:empty {
        display: none;
      }
    }
    .copy-right {
      font-size: 14px;
      line-height: 120%;
      color: rgba(0, 0, 0, .3) !important;
    }
    .zh-copy-right {
      font-size: 14px;
      line-height: 120%;
      color: rgba(0, 0, 0, .3);
      cursor: pointer;
      &:hover {
        color: rgba(0, 0, 0, .55) !important;
      }
    }
    .china-ip-records {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      line-height: 120%;
      color: rgba(0, 0, 0, .3);
      cursor: pointer;
      margin-top: 8px;
      &:hover {
        color: rgba(0, 0, 0, .55) !important;
      }
      img {
        width: 12px;
        height: 12px;
        margin-right: 2px;
      }
    }
  }
  &-r {
    
    a {
      
      width: 24px;
      height: 24px;
      margin-right: 8px;
      cursor: pointer;
      .svg-icon {
        color: var(--color-greyState-activated);
        width: 100%;
        height: 100%;
        &:hover {
          color: rgba(0, 0, 0, .55);
        }
      }
    }
  }
}
</style>